import { Injectable } from '@visiba/instantiation';
import type { RateApiModel } from './generated/clientv2/models';
import { HttpResponse, HttpService } from '@application/http.service';
import { ApiBaseClient } from './_api_base_client';

@Injectable()
export class RateApiService extends ApiBaseClient {
	constructor(private readonly httpService: HttpService) {
		super('rate');
	}

	public getMessagingConversationPrice(receptionId: number): HttpResponse<RateApiModel> {
		return this.httpService.get(`${this.baseUri}/${receptionId}/getMessagingConversationPrice`);
	}
}
